import request from '@/utils/request'
import https from '@/utils/https.js'
export function newsCate() {
    return https({
        url: '/api/news/get_news_cate',
        method: 'post',
        data: {
            area: localStorage.getItem('area')
        }
    })
}
export function newsList(page, cate_id, size) {
    return https({
        url: '/api/news/get_news_list',
        method: 'post',
        data: {
            page: page,
            cate_id: cate_id,
            page_size: size,
            area: localStorage.getItem('area')
        }
    })
}
export function getNewsDetail(id) {
    return https({
        url: '/api/news/get_news_detail',
        method: 'post',
        data: {
            id: id
        }
    })
}
export function getGuideList() {
    return request({
        url: '/web/news/getNewsByCate',
        method: 'post',
        data: {
            area: localStorage.getItem('area')
        }
    })
}